module.exports = __webpack_public_path__ + "img/western-union.d7eaf57d.png";